import { render } from "./view_incident_report.html?vue&type=template&id=5049f851&external"
import script from "./view_incident_report.js?vue&type=script&lang=js&external"
export * from "./view_incident_report.js?vue&type=script&lang=js&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__